import { memo, useCallback, useEffect } from 'react';
import { View, Text, Image, StyleSheet, ScrollView } from 'react-native';

import { I18n, Utils } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __ANDROID__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getAssociatedEmployer } from '../../selectors/employers';
import { getCurrentTopic } from './selector';

function mapStateToProps(state) {
  const employer = getAssociatedEmployer(state);
  return {
    locations: (employer?.uiConfig?.clinicalLocations || []).map((l) => {
      const splitStr = l.split('-');
      return splitStr[splitStr.length - 1];
    }),
    medicalService: getCurrentTopic(state)?.name,
    employer,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )((props) => {
    Utils.employerClinicalLocationImagePath;

    function renderMember(memberLocation) {
      return (
        <View key={memberLocation} style={styles.memberContainer}>
          <View style={[styles.avatarContainer]}>
            <Image
              style={styles.avatar}
              source={{
                uri: Utils.employerClinicalLocationImagePath(
                  props.employer?.employerId,
                  memberLocation
                ),
              }}
              resizeMode="cover"
            />
          </View>
          <View style={styles.textContainer}>
            <Text style={styles.nameText} numberOfLines={2}>
              {props.medicalService?.toUpperCase()}
            </Text>
            <Text style={styles.subNameText} numberOfLines={1}>
              {memberLocation?.toUpperCase()}
            </Text>
          </View>
        </View>
      );
    }

    return (
      <View style={styles.container}>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={styles.horizontalScrollViewContent}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          horizontal={true}
        >
          {props.locations.map(renderMember)}
        </ScrollView>
      </View>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  horizontalScrollViewContent: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  memberContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 0,
    // backgroundColor: 'pink',
  },
  textContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  nameText: {
    ...FONT.bold,
    fontSize: FONT_SIZE.micro,
    color: COLOR.textLight,
    textAlign: 'center',
    paddingTop: 7,
    width: 100,
  },
  subNameText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.micro,
    color: COLOR.textLight,
    textAlign: 'center',
  },
  avatarContainer: {
    backgroundColor: '#efefef',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    width: 40,
    height: 40,
    overflow: 'hidden',
  },
  avatar: {
    width: 40,
    height: 40,
  },
});
